import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Formula = _resolveComponent("Formula")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Formula, { formula: 'cd = Tuesday - ({\\lfloor}\\frac{{yyyy}}{100}{\\rfloor} \\mod 4) * 2' }, null, 8, ["formula"]),
    _createVNode(_component_Formula, {
      formula: 
      '= Tuesday - ({\\lfloor}\\frac{{' +
      _ctx.yyyy +
      '}}{100}{\\rfloor} \\mod 4) * 2'
    
    }, null, 8, ["formula"]),
    _createVNode(_component_Formula, {
      formula: '= 2 - (' + _ctx.floor(this.yyyy / 100) + ' \\mod 4) * 2'
    }, null, 8, ["formula"]),
    _createVNode(_component_Formula, {
      formula: '= 2 - ' + (_ctx.floor(this.yyyy / 100) % 4) + ' * 2'
    }, null, 8, ["formula"]),
    _createVNode(_component_Formula, {
      formula: '= 2 - ' + (_ctx.floor(this.yyyy / 100) % 4) * 2
    }, null, 8, ["formula"]),
    _createVNode(_component_Formula, {
      formula: '= ' + (2 - (_ctx.floor(this.yyyy / 100) % 4) * 2)
    }, null, 8, ["formula"])
  ], 64))
}